module.exports = __webpack_public_path__ + "static/media/ist.3a5f33f3.jpeg";